import { render, staticRenderFns } from "./NolCardGapTest.vue?vue&type=template&id=649c81fc&"
import script from "./NolCardGapTest.vue?vue&type=script&lang=js&"
export * from "./NolCardGapTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports